import { useRequiredParams } from '@pba/react-router';
import { isMongoObjectId } from 'common/utils';
import { EventDetailContent } from './event-detail-content';
import { ProgramEventDetailContent } from './program-event-detail-content';

const PageEventDetail = () => {
  const { eventId } = useRequiredParams<{ eventId: string }>();

  if (isMongoObjectId(eventId)) {
    return <EventDetailContent eventId={eventId} />;
  }

  return <ProgramEventDetailContent eventId={eventId} />;
};

export default PageEventDetail;
